import { useContext } from "react";
import SessionContext from "./context";

const useSessionExist = () => {
    return useContext(SessionContext);
};

export default useSessionExist;
